var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
const _require = require('../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;

/**
  * @function evaluate - evaluate getJobIDBehavior
  */

// designed to be called from the context of a job
// i.e. the content here is a Form representing a Job

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const jobQuerySource = {
    type: 'queryEntityBehavior',
    entityName: 'Job',
    properties: ['id'],
    equals: {
      'form/id': content.id
    }
  };
  const jobs = await evaluateSource(jobQuerySource, content, parentContentPath, transientContext, nativeFunctions);
  if (jobs === undefined || jobs === null || jobs.length < 1) {
    return undefined;
  }
  const _jobs = _slicedToArray(jobs, 1),
    jobID = _jobs[0].id;
  return jobID;
};
module.exports = {
  evaluate
};